import { Box, Grid, Paper, Typography } from "@mui/material";
import { LoanDetail } from "../../types/loan";
import { formatCurrency } from "../../utils/utils";

const VehicleFinanceSummary = ({
  financeInfo,
}: {
  financeInfo: LoanDetail[];
}) => {
  const totalChasisBodyLoan = financeInfo?.reduce(
    (acc, loan) =>
      ["body", "chassis", "chassis+body"].includes(loan.type)
        ? acc + (loan.amount || 0)
        : acc,
    0
  );

  const totalOtherLoan = financeInfo?.reduce(
    (acc, loan) =>
      !["chassis", "body", "chassis+body"].includes(loan.type)
        ? acc + (loan.amount || 0)
        : acc,
    0
  );

  const totalChasisBodyDownPayment = financeInfo?.reduce(
    (acc, loan) =>
      ["body", "chassis", "chassis+body"].includes(loan.type)
        ? acc + (loan.downPayment || 0)
        : acc,
    0
  );

  const totalOtherDownPayment = financeInfo?.reduce(
    (acc, loan) =>
      !["chassis", "body", "chassis+body"].includes(loan.type)
        ? acc + (loan.downPayment || 0)
        : acc,
    0
  );

  return (
    <Paper
      sx={{
        p: 2,
        mb: 2,
      }}
    >
      <Grid container spacing={{ xs: 1, sm: 2 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Total Loan Amount (Chassis + Body)
          </Typography>
          <Typography variant="subtitle1">
            {formatCurrency(totalChasisBodyLoan)}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Total Loan Amount (Other)
          </Typography>
          <Typography variant="subtitle1">
            {formatCurrency(totalOtherLoan)}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Total Down Payment (Chassis + Body)
          </Typography>
          <Typography variant="subtitle1">
            {formatCurrency(totalChasisBodyDownPayment)}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Total Down Payment (Other)
          </Typography>
          <Typography variant="subtitle1">
            {formatCurrency(totalOtherDownPayment)}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default VehicleFinanceSummary;
